'use client';
import React, { memo } from 'react';
import useApplyLogging from '../../hooks/useApplyLogging.mjs';

function IcTxtMainCategoryPay(customProps) {
  const {
    fill,
    ...props
  } = customProps;
  useApplyLogging('ICON_IcTxtMainCategoryPay');
  return /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 35 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.88 5.83998V7.31998H9.12V9.35998H12.88V10.58H15.44V1.47998H12.88V3.81998H9.54C9.56 3.65998 9.56 3.47998 9.56 3.31998V2.27998H0.5V4.53998H6.98C6.56 6.25998 4.18 7.81998 0 8.81998L0.86 11.1C5.06 10.06 7.98 8.45998 9.08 5.83998H12.88ZM5.32 16.88H15.44V11.6H2.68V13.68H12.88V14.82H2.78V20.26H16.04V18.12H5.32V16.88Z",
    fill: fill || 'black'
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9448 20.16H34.4248V1.47998H31.9448V20.16ZM25.2448 8.03998V10.36H27.8848V19.72H30.3048V1.77998H27.8848V8.03998H25.2448ZM23.5048 5.19998H26.5048V2.85998H18.3248V5.19998H21.1848V5.95998C21.1848 9.79998 20.0448 12.96 17.6448 16.18L19.5848 17.66C20.7248 16.12 21.6048 14.52 22.2448 12.86L25.1248 17.46L27.1048 16.1L23.1648 9.65998C23.3848 8.45998 23.5048 7.21998 23.5048 5.95998V5.19998Z",
    fill: fill || 'black'
  }));
}
var IcTxtMainCategoryPay$1 = /*#__PURE__*/memo(IcTxtMainCategoryPay);

export { IcTxtMainCategoryPay$1 as default };
